import type { Theme } from '@hivebrite/design-system/Theme';

import { getColorPresetsArray } from 'hb-builder/utils/colors';

import getColorPresets from './getColorPresets';

const getListColors = ({
  withTransparent,
  theme,
  brandColors,
}: {
  withTransparent: boolean;
  theme: Theme;
  brandColors?: { label: string; value: string }[];
}) => {
  const colorPresets = getColorPresetsArray({
    colors: getColorPresets(),
    theme,
    length: 3,
  });

  return [
    brandColors && {
      name: 'brandColors',
      colors: brandColors.map(({ label, value }) => ({
        label,
        value,
        withTooltip: true,
      })),
    },

    colorPresets && {
      name: 'presets',
      colors: withTransparent
        ? [
            { value: 'transparent' },
            ...colorPresets
              .map((color, index) => ({
                label: `label-${index}`,
                value: color,
              }))
              .splice(1, colorPresets.length),
          ]
        : colorPresets.map((color, index) => ({
            label: `label-${index}`,
            value: color,
          })),
    },
  ].filter(Boolean);
};

export default getListColors;
